import LandingPage from "./LandingPage";

export default function Index() {
  return <LandingPage />;
}
